class MobileMenuNavigation extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();
    this.querySelectorAll('[data-mobile-nav-toggle]').forEach((button) => {
      const panel = this.querySelector('[id="' + CSS.escape(button.getAttribute('aria-controls')) + '"]');
      if (!panel) return;
      button.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    });
    this.addEventListener('click', this.onClick, { signal: this.abortController.signal });
    this.syncNavigationHighlight();
    document.addEventListener('shopify:section:load', this.syncNavigationHighlight, { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  syncNavigationHighlight = () => {
    const items = [...this.querySelectorAll('[data-navigation-title]')];
    items.forEach((item) => item.classList.remove('is-featured'));
    this.style.removeProperty('--header-highlight-color');

    // Mobile is a separate Shopify section; Header owns the shared configuration.
    const header = document.querySelector('theme-header[data-navigation-highlight-enabled="true"]');
    const title = header?.dataset.navigationHighlightTitle?.trim();
    if (!title) return;
    const item = items.find((candidate) => candidate.dataset.navigationTitle.trim() === title);
    if (!item) return;

    this.style.setProperty('--header-highlight-color', getComputedStyle(header).getPropertyValue('--header-highlight-color').trim());
    item.classList.add('is-featured');
  };

  onClick = (event) => {
    const button = event.target.closest?.('[data-mobile-nav-toggle]');
    if (!button || !this.contains(button)) return;
    const panel = this.querySelector('[id="' + CSS.escape(button.getAttribute('aria-controls')) + '"]');
    if (!panel) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
    if (expanded) {
      panel.querySelectorAll('[data-mobile-nav-toggle][aria-expanded="true"]').forEach((nested) => {
        nested.setAttribute('aria-expanded', 'false');
        const nestedPanel = this.querySelector('[id="' + CSS.escape(nested.getAttribute('aria-controls')) + '"]');
        if (nestedPanel) nestedPanel.hidden = true;
      });
    }
  };
}

if (!customElements.get('mobile-menu-navigation')) {
  customElements.define('mobile-menu-navigation', MobileMenuNavigation);
}
